import WeekService from "../../../services/WeekService";

class WeekLabelManager {
  async getWeekNumber(date) {
    return await WeekService.getWeekNumber(date).then(response => response && response.data);
  }
}

export default new WeekLabelManager();
